import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AnalyticsRoutingModule } from './analytics-routing.module';
import { AnalyticsContainerComponent } from './components/analytics-container/analytics-container.component';
import { IncidentAnalyticsContainerComponent } from './components/incident-analytics-container/incident-analytics-container.component';
import { VisitorAnalyticsContainerComponent } from './components/visitor-analytics-container/visitor-analytics-container.component';
import { AnalyticsComponent } from './analytics.component';
import { MaterialModule } from 'src/app/shared/modules/material.module';
import { ChartsModule } from 'src/app/common/modules/charts/charts.module';
import { SharedPipesModule } from 'src/app/shared/pipe/shared-pipes.module';
import { StoreModule } from '@ngrx/store';
import { reducer } from 'src/app/state-management/reducers/analytics.reducer';
import { EffectsModule } from '@ngrx/effects';
import { AnalyticsEffects } from 'src/app/state-management/effects/analytics.effects';
import { SystemLogsComponent } from './components/system-logs/system-logs.component';
import { VisitorTicketsComponent } from './components/visitor-tickets/visitor-tickets.component';
import { DialogPopUpsModule } from 'src/app/common/modules/dialog-pop-ups/dialog-pop-ups.module';
import { ServiceRequestsContainerComponent } from './components/service-requests-container/service-requests-container.component';
import { MobileTableCardModule } from 'src/app/common/modules/mobile-table-card/mobile-table-card.module';
import { ReportsPageDataComponent } from './components/reports-page-data/reports-page-data.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { RiskAnalyticsContainerComponent } from './components/risk-analytics-container/risk-analytics-container.component';
import { RiskDashboardComponent } from './components/risk-dashboard/risk-dashboard.component';
import { EmployeeAttendanceReportComponent } from './components/employee-attendance-report/employee-attendance-report.component';
import { RiskViewAnalyticssComponent } from './components/risk-view-analyticss/risk-view-analyticss.component';
import { PrintableActivityDialogComponent } from './components/printable-activity-dialog/printable-activity-dialog.component';
import { AgGridModule } from 'ag-grid-angular';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatChipsModule } from '@angular/material/chips';
import { ClaimsContainerComponent } from './components/claims-container/claims-container.component';
import { ComplaintsContainerComponent } from './components/complaints-container/complaints-container.component';
const module = [
  CommonModule,
  AnalyticsRoutingModule,
  MaterialModule,
  ChartsModule,
  StoreModule.forFeature('aumyeAnalyticsState', reducer),
  EffectsModule.forFeature([AnalyticsEffects]),
  DialogPopUpsModule,
  MobileTableCardModule,
  NgxMaterialTimepickerModule,
  AgGridModule,
  MatTooltipModule,
  MatChipsModule,
  SharedPipesModule,
];
const component = [
  AnalyticsComponent,
  AnalyticsContainerComponent,
  IncidentAnalyticsContainerComponent,
  VisitorAnalyticsContainerComponent,
  SystemLogsComponent,
  VisitorTicketsComponent,
  ServiceRequestsContainerComponent,
  ClaimsContainerComponent,
  ComplaintsContainerComponent,
  ReportsPageDataComponent,
  RiskAnalyticsContainerComponent,
  RiskDashboardComponent,
  EmployeeAttendanceReportComponent,
  RiskViewAnalyticssComponent,
  PrintableActivityDialogComponent,
];
@NgModule({
  declarations: [...component],
  imports: [...module],
  exports: [
    ServiceRequestsContainerComponent,
    ClaimsContainerComponent,
    ComplaintsContainerComponent,
    ReportsPageDataComponent,
  ],
})
export class AnalyticsModule {}
